// If the browser is internet explorer 10
if (navigator.appVersion.indexOf("MSIE 10") !== -1) {
    document.documentElement.className+=' br-ie10';
}
